<!--  Documentation
https://xd.adobe.com/view/d78cbc0b-fa27-47d4-9328-317ef5da0e00-82df/
https://xd.adobe.com/view/edceed8a-147c-4439-b6c0-0e22c2baaf97-b89d/
https://docs.google.com/presentation/d/1ZaGS81AShykqKAS8sPy1v_jBT9htmkaXZiOPVxIHzWQ/edit#slide=id.p
https://docs.google.com/presentation/d/15wZry0tJDrIE0dhOvHwHrc-uaGefN5p5CxEzMHgYlZE/edit#slide=id.p
-->
<template>
  <div id="mangellist" class="clearfix px3 notosans darkblue mx2">
      <div class="mt2 pointer" @click="gotodashboard()">
        <i class="el-icon-back"></i>
      </div>
      <div class="mt2 my3">
            <p class="h3 col-12 line-height-golden bold p0">Ekstra arbejde</p>
      </div>
      <div class="flex col-12 p0 mobile-flex-column">
      <div class="clearfix flex ml-auto items-center xs-gap-10 gap-20">
        <p @click="editingitem = !editingitem" class="h5 flex items-center py1 rounded" v-if="(getExtraWorkList || extraworkStatus !== 'approved') && extraworkStatus !== ''">
          <span class=""><i class="h5 darkblue m0 el-icon-circle-plus-outline"></i></span>
          <span class="pl2 darkblue">Redigere</span>
        </p>
      </div> 
      </div>
      <div class="col-12" v-if="loading">
        <Loading></Loading>
      </div>
      <div class="flex flex-column " v-else>
        <div class="darkblue-background px3 m0 col-12 flex white justify-end items-center py1 rounded light-highlights">
          <p class="white p0 m0">Deadline: </p>
          <p class="semi-bold h5 mx2" v-if="getExtraWorkList && !editingitem">{{moment(deadline).locale('da').format('LL')}}</p>
          <el-date-picker v-else v-model="deadline" size="large" format="yyyy/MM/dd" value-format="yyyy-MM-dd" type="date" placeholder="start" :picker-options="pickerOptions" class="px0 white-background mx2 rounded"></el-date-picker>
        </div>
        <div  class="" v-if="getExtraWorkList && !editingitem">
          <div class="border light-highlights p3 flex col-12 p0" :key="index">
            <p class="p0 m0 h5">{{getExtraWorkList.DESCRIPTION }}</p>
            <div class="ml-auto p0 m0">{{Number(getExtraWorkList.AMOUNT).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:0})}}</div>
          </div>
          <div class="py2 m0 ml-auto flex justify-end mt2 items-center gap-10">
            <button class="dark-button p2 rounded" @click="opensignature(getExtraWorkList.ID)" v-if="lastUpdatedBy === 'homeowner'">
              <span class="font12 center">Godkende</span>
            </button>
          </div>
          <div class="py4">
          </div>
        </div>
        <div v-else>
          <div class="border light-highlights p2 flex flex-column">
            <div class="px3 mt1 flex flex-column mb2">
              <el-input :autosize="{ minRows: 4, maxRows: 6 }" type="textarea" placeholder="Arbejdsbeskrivelse" class="border" v-model="description"></el-input>
              <el-input type="nummber" v-model.number="pris"  placeholder="pris" class="white-background ml-auto mt2 col-2 m0 p0"></el-input>
            </div>
          </div>
          <div class="p0 m0 ml-auto flex justify-end mt2 items-center gap-10">
            <p class="semi-bold m0 pointer" @click="saveExtrawork(false)" v-if="!editingitem">Gem som kladde</p>
            <!-- <p class="semi-bold m0 pointer" @click="updateExtrawork()" v-else>Opdatere  som kladde</p> -->
            <button class="dark-button p2 rounded" @click="opensignature()">
              <span class="font12 center" v-if="!editingitem">Gem & send til håndværker</span>
              <span class="font12 center" v-else>Opdatere & send til håndværker</span>
            </button>
          </div>
        </div>
      </div>
    <b-modal  centered hide-header hide-footer id="signaturepopup" ref="signaturepopup">
      <div class="col-12 flex justify-end items-center white-background px0 ">
        <button type="button" @click="closesignature()" class="white-button no-border not-rounded ">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <div class="col-12" v-if="signatureloading">
        <Loading></Loading>
      </div>
      <div class="py1 col-12 p0 relative" style="width:100%;height:95%;overflow:auto;" v-else>
        <div class="flex col-12 p0">
          <p class="darkblue">Underskriv her</p>
          <button id="clear-button" class="white-backgroud px2 red border red-border ml-auto" @click="clearSignature()">RYD</button>
        </div>
        <div class="col-12 p0 border muted-border mx-auto"  id="signature-control" >
          <!-- <ejs-signature id="signature" class="mt0" height="300px" width="468px"></ejs-signature> -->
          <div id="signature-pad" class="signature-pad col-12 height-full">
            <div class="signature-pad--body">
              <canvas width="664" style="touch-action: none; user-select: none;" height="339"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 p0 flex items-center my2">
        <p class="mr-auto p0 py2 m0 h6"><el-checkbox class="saveSignature" v-model="confirmTerms"><span class="pointer">{{termslabel}}</span><span class="primarycolor semi-bold pl1" @click="termspopupmangel = true">{{termslinkablework}}</span></el-checkbox></p>
        <button type="button" class=" ml-auto action-button button-padding border-none not-rounded h5 regular line-height-1 p2" @click="sendforApproval(activeextraID)" v-if="!editingitem && lastUpdatedBy === 'homeowner'">
          Godkende
        </button>
        <button type="button" class=" ml-auto action-button button-padding border-none not-rounded h5 regular line-height-1 p2" @click="saveExtrawork(true)" v-else-if="!editingitem && lastUpdatedBy === ''">
          Godkende
        </button>
        <button type="button" class=" ml-auto action-button button-padding border-none not-rounded h5 regular line-height-1 p2" @click="updateExtrawork(activeextraID)" v-else-if="editingitem">
          Godkende
        </button>
      </div>
    </b-modal>
    <b-modal  centered hide-header size="lg" hide-footer id="termspopupmangel" v-model="termspopupmangel"  ref="termspopupmangel">
      <div class="col-12 flex justify-end items-center white-background ">
        <button type="button" @click="termspopupmangel = false" class="white-button no-border not-rounded gibson ">
          <span>
          <i class="el-icon-close"></i>
          </span>
        </button>
      </div>
      <div class="py1 col-12 relative" style="width:100%;height:95%;">
        <iframe :src="termslink" frameborder="0" style="overflow:hidden;padding:10px;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px;background-color:#ffff;" height="100%" width="100%">
        </iframe>
      </div>
    </b-modal>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import SignaturePad from 'signature_pad'
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'extraworklist',
  components: {
    Simplert,
    ErrorHandler,
    Loading,
    SignaturePad
  },
  data: function () {
    return {
      loading: false,
      haaid: '',
      showMobile: false,
      salesPersonbitrix: '',
      pickerOptions: {
        disabledDate (time) {
          return (time.getTime() - (-86400000)) < Date.now()
        }
      },
      projectId: '',
      contractType: '',
      childprojects: [],
      partnerchildprojects: [],
      deadline: null,
      checked: false,
      incompleteModal: false,
      jobindustryBranch: [],
      itemsjobindustry: {},
      formLoading: false,
      commentloading: false,
      modalimageloading: false,
      addItemForm: {
        branch: [],
        title: '',
        beskrivelse: ''
      },
      addItemFormRules: {
        title: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit title',
          trigger: 'blur'
        }],
        beskrivelse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit beskrivelse',
          trigger: 'blur'
        }],
        branch: [{
          type: 'array',
          required: true,
          message: 'Du bedes indtaste dit tag',
          trigger: 'change'
        }]
      },
      acceptedFileType: '.jpg,.png,.pdf,.pptx',
      getExtraWorkList: {},
      isPreApprove: false,
      description: '',
      isFinalApprove: false,
      lastUpdatedBy: '',
      pris: null,
      termspopupmangel: false,
      termsdata: [],
      termslabel: 'Accepter vores betingelser',
      termslink: 'http://www.haandvaerker.dk/om/betingelser',
      signaturePad: '',
      confirmOffer: false,
      confirmTerms: false,
      termsloading: true,
      termslinkablework: 'betingelser',
      editingitem: false,
      signbypartner: false,
      signbyhomeowner: false,
      activeextraID: null,
      currentProjectData: {},
      signatureloading: false,
      extraworkStatus: ''
    }
  },
  watch: {
  },
  created () {
    this.projectId = this.$route.query.projectId
    this.contractID = this.$route.query.contractId
    this.contractType = this.$route.query.contracttype ? this.$route.query.contracttype : ''
    this.contactId = this.$route.query.contactId ? this.$route.query.contactId : ''
    this.haaid = localStorage.getItem('haaid')
    this.childprojects = this.$route.query.childprojects ? JSON.parse(this.$route.query.childprojects) : []
    if (this.childprojects.length > 0) {
      this.childprojects.forEach(o => {
        if (o.IS_PARTNER) {
          this.partnerchildprojects.push(o.ID)
        }
      })
    }
    this.gettaskbitrix()
    this.getextraworkList()
    this.getTermsCondition()
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
    displayProjects () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + this.projectId, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.contractType = res.CONTRACT_TYPE
          this.contactId = res.HOMEOWNER.ID
          this.childprojects = res.CHILD_PROJECTS
          this.currentProjectData = res
        },
        response => {
          this.loading = false
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
        })
    },
    gettaskbitrix () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      this.$http.get(this.$bitrixapi + 'industries/full/', {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var industryname = {}
            this.jobindustryBranch = []
            res.data.forEach(l => {
              var industryBranch = {}
              industryBranch.key = l.BRANCHE_ID
              industryBranch.value = l.BRANCHE_ID
              industryBranch.label = l.BRANCHE
              this.jobindustryBranch.push(industryBranch)
              industryname[l.BRANCHE_ID] = l.BRANCHE
            })
            this.itemsjobindustry = industryname
          }
        },
        (response) => {
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    getextraworkList () {
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.$http.get(this.$bitrixapi + 'partner/extra_work?size=30&page=1&contractId=' + this.contractID, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var filteredlist = res.data.items.EXTRA_WORKS.filter(l => { return (l.DATE_SIGNED_BY_CONTACT === '' || l.DATE_SIGNED_BY_PARTNER === '') && (l.STAGE === 'draft' || l.STAGE === 'for_approval') })
            this.getExtraWorkList = filteredlist[0]
            this.deadline = this.getExtraWorkList ? this.getExtraWorkList.END_DATE : null
            this.signbypartner = this.getExtraWorkList && this.getExtraWorkList.DATE_SIGNED_BY_PARTNER !== ''
            this.signbyhomeowner = this.getExtraWorkList && this.getExtraWorkList.DATE_SIGNED_BY_CONTACT !== ''
            this.lastUpdatedBy = this.getExtraWorkList ? this.getExtraWorkList.LAST_UPDATED_BY : ''
            this.extraworkStatus = this.getExtraWorkList ? this.getExtraWorkList.STAGE : ''
            this.description = this.getExtraWorkList ? this.getExtraWorkList.DESCRIPTION : ''
            this.pris = this.getExtraWorkList ? this.getExtraWorkList.AMOUNT : 0
            this.activeextraID = this.getExtraWorkList ? this.getExtraWorkList.ID : null
          }
          this.loading = false
          this.closesignature()
          this.displayProjects()
        },
        (response) => {
          this.loading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        }
      )
    },
    changeenddate () {
      this.$confirm('Ønsker du at ændre fristen, vil dette påvirke alle varer på listen?', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(() => {
        this.formLoading = true
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {}
        this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/updateDeficiencyEndDate', data, { headers }, { emulateJSON: true }).then(
          response => {
            this.getDefiency(this.projectId)
          },
          response => {
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          })
      }).catch(() => {
      })
    },
    saveExtrawork (includedapproval) {
      if (this.deadline === '') {
        this.$message({
          type: 'error',
          message: 'Indtast venligst en slutdato for alle varer på listen'
        })
        return false
      }
      if (this.description === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en beskrivelse af arbejdet'
        })
        return false
      }
      if (this.pris === null || this.pris < 1) {
        this.$message({
          type: 'error',
          message: 'Indtast venligst pris'
        })
        return false
      }
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        contractId: this.contractID,
        source: 'web',
        price: parseFloat(this.pris),
        endDate: this.deadline,
        description: this.description
      }
      this.$http.post(this.$bitrixapi + 'partner/extra_work', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body.data.ID
          this.getextraworkList()
          this.closesignature()
          if (includedapproval) {
            this.sendforApproval(res)
          } else {
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          }
        },
        response => {
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
        })
    },
    updateExtrawork () {
      if (this.deadline === '') {
        this.$message({
          type: 'error',
          message: 'Indtast venligst en slutdato for alle varer på listen'
        })
        return false
      }
      if (this.description === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en beskrivelse af arbejdet'
        })
        return false
      }
      if (this.pris === null || this.pris < 1) {
        this.$message({
          type: 'error',
          message: 'Indtast venligst pris'
        })
        return false
      }
      this.loading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        source: 'web',
        price: parseFloat(this.pris),
        endDate: this.deadline,
        description: this.description
      }
      this.$http.post(this.$bitrixapi + 'partner/extra_work/update/' + this.activeextraID, data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body.data.ID
          this.editingitem = false
          this.sendforApproval(res)
        },
        response => {
          var error = response.body
          this.$message({
            type: 'error',
            message: error.message
          })
        })
    },
    sendforApproval (id) {
      this.closesignature()
      if (!this.confirmTerms) {
        this.$message.error('Bekræft venligst din tilbudsoversigt')
        return false
      }
      this.loading = true
      this.signatureloading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        signaturePng: this.signaturePad.toDataURL(),
        paymentStages: [{
          project_id: this.projectId,
          partner_id: this.haaid,
          contact_id: this.contactId,
          calculation_id: 0,
          industry_id: '0',
          job_industry_id: '0',
          price_total: this.pris,
          sub_project_id: '0',
          vat_total: parseFloat(this.pris * 1.25),
          transaction_fee: '',
          note: '',
          signature: '',
          weeks: '',
          start_date: '',
          end_date: this.deadline,
          contract_type: 'extra_work',
          offer_id: '0',
          description_payment: []
        }]
      }
      this.$http.post(this.$bitrixapi + 'partner/extra_work/' + id + '/approve', data, { headers }, { emulateJSON: true }).then(
        response => {
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          this.getextraworkList()
        },
        response => {
          this.loading = false
          this.signatureloading = false
          var error = response.body.message
          this.$message({
            type: 'error',
            message: error
          })
        })
    },
    deleteDeficiency (deficiencyId) {
      this.$confirm('Hej, er du sikker på, at du vil slette dette element', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(() => {
        this.formLoading = true
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {}
        this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency/' + deficiencyId, data, { headers }, { emulateJSON: true }).then(
          response => {
            this.formLoading = false
            this.getDefiency(this.projectId)
          },
          response => {
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          })
      }).catch(() => {
      })
    },
    openEditModal () {
      this.editincompleteModal = true
    },
    closeEditincompleteModal (item) {
      this.editincompleteModal = false
    },
    getTermsCondition () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopup', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.termsdata = res.filter(l => { return l.TYPE === 'Partner' })[0]
          this.termslink = this.termsdata.LINK
          var labelarroriginal = this.termsdata.LABEL.split(' ')
          var labelarr = this.termsdata.LABEL.split(' ')
          labelarr.pop()
          this.termslabel = labelarr.join(' ')
          this.termslinkablework = labelarroriginal[labelarroriginal.length - 1]
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    initiateSignaturepad () {
      setTimeout(() => {
        var canvas = document.querySelector('canvas')
        this.signaturePad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)'
        })
      }, 200)
    },
    closesignature () {
      this.$refs['signaturepopup'].hide()
    },
    clearSignature () {
      var signature = this.signaturePad
      signature.clear()
    },
    opensignature () {
      this.initiateSignaturepad()
      if (this.deadline === '') {
        this.$message({
          type: 'error',
          message: 'Indtast venligst en slutdato for alle varer på listen'
        })
        return false
      }
      if (this.description === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en beskrivelse af arbejdet'
        })
        return false
      }
      if (this.pris === null || this.pris < 1) {
        this.$message({
          type: 'error',
          message: 'Indtast venligst pris'
        })
        return false
      }
      this.$refs['signaturepopup'].show()
    },
    gotodashboard () {
      this.$router.push('/customer-projects/project-dashboard?projectId=' + this.currentProjectData.ID + '&contactID=' + this.currentProjectData.HOMEOWNER.ID + '&parentID=' + this.currentProjectData.PARENT_ID + '&industryID=' + this.currentProjectData.ENTERPRISE_INDUSTRY + '&offertype=' + this.currentProjectData.OFFER_TYPE + '&childprojects=' + JSON.stringify(this.currentProjectData.CHILD_PROJECTS) + '&contracttype=' + this.currentProjectData.CONTRACT_TYPE + '&projecttitle=' + this.currentProjectData.NAME)
    }
  }
}
</script>
<style>
#termspopupmangel .modal-body {
  height:800px;
}
#signaturepopup .modal-content {
  padding: 17px
}
#termspopupmangel .modal-content {
  width:1200px;
}
#termspopupmangel {
  left: -20%!important;
}
#termspopupmangel .el-input-inner {
  text-align: right;
}
.font14 {
  font-size: 14px;
}
.font12 {
  font-size: 12px;
}
.gap-10 {
  gap: 10px
}

</style>



// WEBPACK FOOTER //
// extraworklist.vue?876d3736